import { Entity } from "@hds/entity-lib";

class ItemEngineStateEntity extends Entity {
    static DEFAULT_DOCUMENT = {
        eventTypeBiddingRules: {},
        biddingRules: {},
        prebids: []
    };
    constructor(entityPersistence, seedData = {}, options = {}) {
        super(entityPersistence, seedData, options);
        this._virtualDataModel.fromJSON({
            ...ItemEngineStateEntity.DEFAULT_DOCUMENT,
            ...seedData
        });
    }
    /*****************************************************/
    // START ENTITY DATA MODEL
    /*****************************************************/
    get eventDetailId() {
        return this._virtualDataModel.getProperty('eventDetailId');
    }
    set eventDetailId(newEventDetailId) {
        return this._virtualDataModel.setProperty('eventDetailId', newEventDetailId);
    }
    get itemId() {
        return this._virtualDataModel.getProperty('itemId');
    }
    set itemId(newItemId) {
        return this._virtualDataModel.setProperty('itemId', newItemId);
    }
    get biddingRules() {
        return this._virtualDataModel.getProperty('biddingRules');
    }
    set biddingRules(newBiddingRules) {
        return this._virtualDataModel.setProperty('biddingRules', newBiddingRules);
    }
    get eventTypeBiddingRules() {
        return this._virtualDataModel.getProperty('eventTypeBiddingRules');
    }
    set eventTypeBiddingRules(newEventTypeBiddingRules) {
        return this._virtualDataModel.setProperty('eventTypeBiddingRules', newEventTypeBiddingRules);
    }
    get prebids() {
        return this._virtualDataModel.getProperty('prebids');
    }
    set prebids(newPrebids) {
        return this._virtualDataModel.setProperty('prebids', newPrebids);
    }
    /*****************************************************/
    // END ENTITY DATA MODEL
    // START OVERRIDDEN METHODS
    /*****************************************************/
    clone() { throw new Error('METHOD_NOT_ALLOWED'); }
    /*****************************************************/
    // END OVERRIDDEN METHODS
    /*****************************************************/
}
//META PROPERTIES
Object.defineProperty(ItemEngineStateEntity.prototype, '_meta', {
    value: {
        storeName: 'event-runtime',
        entityName: 'item-engine-state'
    }
}, { enumerable: false, configurable: false, writable: false, value: "static" });

export { ItemEngineStateEntity };
export default ItemEngineStateEntity;